import { jsxs as i, jsx as C } from "react/jsx-runtime";
const t = (l) => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "38",
    height: "42",
    viewBox: "0 0 38 42",
    fill: "none",
    ...l,
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M21.3211 12.3228C21.2612 12.6186 21.3211 13.2694 21.1414 13.506C20.8419 13.8609 20.183 13.8609 19.7638 13.8609C17.9668 13.9201 16.1099 13.8609 14.3129 13.6243C14.0733 13.6243 13.8337 13.5651 13.654 13.3877C13.5342 13.2694 13.5342 13.0327 13.4743 12.8552C13.2946 10.7256 13.3545 8.53672 13.5941 6.40703C13.5941 6.22956 13.654 5.99292 13.7738 5.87461C13.9535 5.75629 14.1332 5.75629 14.3728 5.75629C16.4094 5.81545 18.5059 5.93377 20.5424 6.11124C20.782 6.11124 21.6206 6.64366 21.5008 6.82113C21.5607 6.82113 21.5008 10.5481 21.3211 12.3228Z",
          fill: "#B8DDF0"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M19.8237 12.3228C19.7638 12.6186 19.7638 12.6778 19.9434 12.5003C20.183 12.3228 20.1231 12.3228 19.7039 12.382C19.2846 12.2637 18.6257 12.382 18.2064 12.382C17.6673 12.382 15.2114 12.5595 14.9119 12.2045C14.7921 12.0862 14.9119 10.3706 14.9119 9.95651C14.9119 9.18746 14.6723 7.35356 15.0916 6.70282C14.7921 6.93945 14.4926 7.17608 14.1931 7.35356C15.2114 6.93945 17.0084 7.35356 18.0866 7.47187C18.3262 7.47187 20.183 7.76766 20.2429 7.64935C19.7638 8.30009 20.2429 6.22956 20.0033 7.23524C19.8237 7.88598 20.0033 8.83251 19.9434 9.5424C19.9434 10.4298 19.9434 11.3763 19.8237 12.3228C19.644 14.2159 22.6389 14.2159 22.8186 12.3228C22.9983 10.8439 22.9983 9.36493 22.9983 7.82682C22.9983 6.93945 23.0582 6.11124 22.3394 5.4605C20.9617 4.15903 18.5658 4.45482 16.8287 4.39566C15.3312 4.3365 12.9951 3.80408 12.2763 5.57882C11.5576 7.2944 11.8571 9.89735 11.917 11.6721C11.9769 13.3877 12.1565 14.6891 14.0733 15.0441C16.05 15.399 18.446 15.5174 20.4825 15.2216C22.2196 14.9849 22.6988 13.8609 22.8186 12.2637C22.9384 10.4298 19.9434 10.4298 19.8237 12.3228Z",
          fill: "#B8DDF0"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M19.9122 20.0449C19.9122 19.3966 19.3991 18.8873 18.7927 18.8873L14.3145 18.8409C14.0813 18.8409 13.8014 18.8409 13.6148 19.0262C13.4282 19.2114 13.3816 19.4893 13.3349 19.7208C13.195 20.8785 13.0084 22.0825 13.1483 23.2865C13.195 23.8885 13.4282 24.6294 13.988 24.8146C14.1746 24.9072 14.3612 24.9072 14.5944 24.9072C15.9005 24.9535 17.2066 24.9072 18.5128 24.8146C18.746 24.8146 19.0259 24.7683 19.2125 24.6294C19.4457 24.4442 19.539 24.1663 19.5857 23.8885C19.8189 22.8697 19.9122 21.1563 19.9122 20.0449Z",
          fill: "#F68559"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M21.0784 20.0449C20.7985 17.5443 18.6061 17.7296 16.6935 17.7296C15.9005 17.7296 15.1075 17.6833 14.3612 17.7296C12.5886 17.7759 12.262 18.9799 12.0755 20.508C11.8889 21.9436 11.609 23.9348 12.5886 25.1851C13.5215 26.4354 15.3874 26.1112 16.7402 26.0649C18.1862 26.0186 19.8655 26.1575 20.5186 24.6294C21.125 23.2402 21.0784 21.4805 21.0784 20.0449C21.125 18.5631 18.7927 18.5631 18.746 20.0449C18.746 20.9711 18.746 21.9436 18.5594 22.916C18.5594 23.0549 18.4661 23.6106 18.4661 23.6569C18.3728 23.7496 17.16 23.7496 17.0201 23.7496C16.367 23.7959 14.6877 24.0737 14.3612 23.4717C14.1279 23.0549 14.1746 20.7396 14.4545 20.2765C14.6411 19.9523 14.1746 20.1376 14.781 20.0449C15.2941 19.9523 15.9005 20.0449 16.4136 20.0449C16.5536 20.0449 18.746 19.9986 18.746 20.0449C18.9326 21.4805 21.265 21.5268 21.0784 20.0449Z",
          fill: "#F68559"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M9.1833 15.6472C9.13665 15.0915 8.62353 14.6747 8.01712 14.6747L4.47193 14.86C4.28534 14.86 4.09875 14.86 3.91216 14.9526C3.35239 15.2304 3.21245 16.064 3.21245 16.7123C3.21245 17.5921 2.79263 20.6021 3.72557 20.6947C5.21828 20.8799 7.08417 20.8336 8.57688 20.8336C8.71683 20.8336 8.90341 20.8336 8.99671 20.6947C9.09 20.6021 9.13665 20.4632 9.13665 20.3706C9.50983 19.1666 9.32324 16.9438 9.1833 15.6472Z",
          fill: "#B8DDF0"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M10.3028 15.323C9.64977 12.915 6.89758 13.5633 4.98505 13.656C3.95881 13.7023 3.07251 13.8412 2.51275 14.8137C1.99963 15.7861 2.09292 17.129 2.04627 18.1941C1.99963 19.2129 1.95298 20.4632 2.65269 21.2967C3.58563 22.3618 5.8247 22.0376 7.03753 22.0376C8.57688 22.0376 9.9763 22.2229 10.3961 20.4632C10.7693 18.935 10.5361 17.2216 10.3495 15.6472C10.1629 14.1653 7.83053 14.1653 8.01712 15.6472C8.11041 16.5733 8.20371 17.4995 8.20371 18.4256C8.20371 18.7498 8.01712 19.537 8.15706 19.8149C8.11041 19.7223 9.09 19.7686 8.25035 19.7223C7.97047 19.7223 7.73723 19.7223 7.45735 19.7223C6.38446 19.7223 5.26493 19.5833 4.19204 19.6296C4.56522 19.6296 4.28534 20.0927 4.42528 19.6759C4.47193 19.5833 4.37863 19.3981 4.37863 19.2592C4.33199 18.8887 4.37863 18.472 4.37863 18.0552C4.37863 17.5921 4.28534 16.7123 4.47193 16.2492C4.61187 15.8324 4.79846 15.9713 5.26493 15.925C5.63811 15.925 7.97047 15.6009 8.06376 15.8787C8.43694 17.3606 10.676 16.7586 10.3028 15.323Z",
          fill: "#B8DDF0"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M17.081 7.62704C17.3953 7.27536 17.7147 6.92931 18.0399 6.59124C19.28 5.22061 21.3469 7.19431 20.1658 8.51012C19.8062 8.87298 19.4591 9.24353 19.121 9.61973C19.6448 10.127 20.171 10.6343 20.6972 11.1416C22.0554 12.4025 19.9296 14.3216 18.6304 13.0606C18.1967 12.6257 17.7578 12.1908 17.3153 11.7559C17.0236 12.1166 16.7345 12.479 16.4454 12.8413C15.973 13.4444 15.2053 13.7733 14.4375 13.3347C13.788 13.0058 13.4336 12.0738 13.9061 11.4707C14.3526 10.9053 14.8062 10.3335 15.2691 9.76405C14.8745 9.38262 14.4789 9.0012 14.0832 8.61977C12.784 7.35879 14.8509 5.38508 16.1501 6.70089C16.458 7.0096 16.7685 7.31832 17.081 7.62704Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M7.31743 16.0189C6.33783 15.1391 4.75183 15.4169 4.14542 16.6209C3.539 17.8249 3.91218 19.5383 5.3116 19.9551C6.47778 20.3255 7.83055 19.6309 8.20372 18.4732C8.5769 17.2229 7.83055 16.0652 6.66437 15.6021C6.05795 15.3706 5.40489 15.8337 5.2183 16.3894C5.03171 17.0377 5.45154 17.5934 6.0113 17.8249C5.96466 17.8249 5.91801 17.7786 5.87136 17.7323C6.05795 17.9175 5.87136 17.686 5.91801 17.7786C5.96466 17.9175 5.91801 17.6397 5.91801 17.8249C5.91801 17.9638 5.91801 17.7323 5.91801 17.686C5.91801 17.8249 5.82472 17.7786 5.91801 17.7323C6.05795 17.5934 5.82472 17.7786 5.91801 17.7323C5.96466 17.7323 6.05795 17.6397 5.96466 17.686C5.91801 17.686 5.87136 17.686 5.96466 17.686C6.05795 17.686 6.0113 17.686 5.91801 17.686C6.1046 17.7786 6.05795 17.7786 6.19789 17.9638C6.15125 17.9175 6.15125 17.7323 6.19789 17.686C6.19789 17.7786 6.19789 17.7323 6.24454 17.5934V17.6397L6.15125 17.7323C6.1046 17.7323 6.1046 17.7323 6.05795 17.7786C6.19789 17.7323 6.19789 17.7323 6.1046 17.7786C5.96466 17.7786 5.82472 17.7786 5.68477 17.6397C6.15125 18.0564 6.85095 18.1027 7.31743 17.6397C7.7839 17.2229 7.7839 16.4357 7.31743 16.0189Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M33.6136 8.83657C33.3591 9.39585 33.8681 9.14163 33.2573 9.09079C32.952 9.03995 32.5957 8.88741 32.2904 8.78573C31.527 8.5315 30.3055 8.27728 29.6948 7.718C29.2877 7.36209 29.3386 7.56547 29.2877 7.10787C29.2368 6.59943 29.7966 5.88761 30.0511 5.43002C30.4582 4.7182 31.0689 3.19288 31.6797 2.73528C31.3743 2.83697 31.0689 2.9895 30.7636 3.09119C31.6797 3.04034 33.1556 4.05723 34.0207 4.41313C34.4788 4.61651 34.9368 4.92158 35.4457 5.07411C34.9877 4.92158 35.7511 4.31145 35.344 4.87073C34.5806 5.9893 34.2243 7.56547 33.6136 8.83657C32.8502 10.311 35.0895 11.5821 35.802 10.1077C36.4636 8.78573 37.0234 7.41294 37.5833 6.04015C37.9904 5.07411 38.1431 4.41313 37.4306 3.49794C36.3618 2.12515 33.8172 1.51502 32.2395 0.854049C30.5091 0.193076 29.7966 0.701517 28.9314 2.22684C27.5064 4.7182 25.0636 7.92138 28.4225 9.85345C29.6439 10.5653 31.0689 11.0737 32.4431 11.4805C34.0716 11.9381 35.0895 11.6838 35.802 10.1077C36.4636 8.63319 34.2752 7.31125 33.6136 8.83657Z",
          fill: "#F68559"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M33.625 4.50272C32.927 3.92367 31.88 3.63414 31.1239 4.09739C30.7749 4.2711 30.4841 4.61854 30.3096 5.02387C29.9606 5.71874 30.0187 6.58732 30.3677 7.22428C30.7749 7.91914 31.4729 8.38239 32.2872 8.44029C33.276 8.4982 34.323 7.91914 34.6138 6.99266C34.9046 6.06617 34.323 5.08178 33.625 4.50272Z",
          fill: "#F68559"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M34.6138 3.46043C33.1015 2.24441 30.8912 1.89698 29.4952 3.51833C28.1574 5.08178 28.3319 7.57171 29.9024 8.90353C31.4147 10.1775 33.7413 10.1775 35.1373 8.67191C36.6496 7.10847 36.1843 4.79225 34.6138 3.46043C33.2178 2.24441 31.1239 4.2711 32.578 5.48712C32.8688 5.77664 33.3923 6.18198 33.1015 6.64522C32.8688 6.99266 32.2872 6.99266 31.9382 6.81894C31.0657 6.29779 31.5892 4.79225 32.578 5.54502C33.2178 6.00826 34.0322 6.12407 34.6138 5.54502C35.1373 5.02387 35.2536 3.92367 34.6138 3.46043Z",
          fill: "#F68559"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M15.1542 25.7895C12.5886 25.0023 5.03178 20.9735 3.58572 25.6506C2.88601 27.9197 5.17172 29.9109 6.89767 31.0223C9.50992 32.6431 12.6819 33.4303 15.714 33.8934C17.1601 34.1249 17.8131 31.9021 16.3204 31.6706C14.5478 31.3927 12.7286 31.0223 11.0493 30.4203C10.0697 30.0498 5.03178 28.0123 5.96473 26.3915C6.57114 25.2801 8.81021 25.9748 9.6965 26.3452C11.2825 26.9935 12.9152 27.5029 14.5478 28.0123C15.9939 28.4754 16.6003 26.2526 15.1542 25.7895Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M33.2067 20.8346C32.2271 18.3803 30.6878 14.3052 27.3292 14.4905C25.0434 14.6294 23.6907 17.2689 23.9706 19.3065C24.1571 20.5568 24.5303 21.7608 24.8569 22.9185C24.9968 23.5668 26.023 26.2063 25.5566 26.762C25.0434 27.4103 21.7781 27.0398 20.9385 26.9935C18.9327 26.9009 17.0668 26.2989 15.1542 25.7432C13.7082 25.3265 13.1018 27.5492 14.5478 27.966C17.4866 28.8458 20.2854 29.4478 23.4108 29.3552C25.0434 29.3089 27.3758 29.3089 27.8423 27.364C28.3554 25.3265 27.2359 22.6869 26.7227 20.742C26.4895 19.8158 26.023 18.7508 26.4429 17.8246C28.0755 14.4905 30.5012 20.2326 30.9676 21.3903C31.5274 22.8258 33.7665 22.2238 33.2067 20.8346Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M24.2504 40.8395C27.9356 39.7744 31.7606 38.0147 33.8131 34.6343C35.5391 31.7632 35.5391 28.4291 34.6528 25.2801C34.2329 23.8446 31.9939 24.4466 32.4137 25.8821C34.3262 32.6431 29.9414 36.8107 23.644 38.6167C22.198 38.9872 22.8044 41.2563 24.2504 40.8395Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M3.77231 25.2801C-0.239355 25.4654 -0.379296 29.6331 1.95307 32.0874C5.31167 35.653 10.7694 37.3201 15.4808 37.9221C16.9735 38.1073 16.9735 35.792 15.4808 35.6067C12.3087 35.19 9.18339 34.1712 6.4312 32.5967C5.40496 31.9947 4.37872 31.3464 3.58572 30.4666C3.02595 29.8646 1.76648 27.6881 3.77231 27.6418C5.26502 27.5492 5.26502 25.2338 3.77231 25.2801Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M12.7286 41.4878C16.7402 41.8583 20.2388 41.8583 24.1571 40.8395C25.6032 40.469 24.9968 38.2463 23.5507 38.6167C19.819 39.5892 16.5536 39.5429 12.7286 39.1724C11.2359 39.0335 11.2359 41.3489 12.7286 41.4878Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M1.11341 31.1149C-2.33848 35.7457 4.23878 39.0798 7.97056 40.2375C9.41662 40.7006 10.023 38.4315 8.57697 38.0147C7.08426 37.5517 5.6382 36.7181 4.28543 35.9309C2.69942 34.9584 1.81312 33.986 3.0726 32.3189C4.00554 31.1149 1.99971 29.9572 1.11341 31.1149Z",
          fill: "#1E2882"
        }
      )
    ]
  }
), e = (l) => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "33",
    height: "42",
    viewBox: "0 0 33 42",
    fill: "none",
    ...l,
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M0.571409 18.999C1.00003 26.7133 0.830422 28.7022 0.604035 37.1971C0.558758 38.7537 0.377649 40.7552 1.78125 41.5112C2.46041 41.8671 3.86401 41.6447 4.63372 41.6447C8.4823 41.6447 12.3309 41.6447 16.1795 41.6002C18.715 41.6002 21.2052 41.6002 23.7408 41.6002C24.6011 41.6002 25.5066 41.6002 26.3216 41.3778C27.1366 41.1554 27.9516 40.6662 28.3591 39.9101C28.6307 39.3764 28.7666 38.7982 28.7666 38.1756C28.6307 30.8815 27.5472 24.2667 28 16.8392C25.6003 17.195 23.1592 16.9282 20.7142 16.8392C20.0804 16.7947 19.8813 16.8723 19.4285 16.4276C19.0663 16.0718 18.6619 15.6311 18.5714 15.1419C18.3903 14.0745 18.9094 11.1109 19 9.99897C16.1491 9.85777 12.4864 9.84615 8.2857 9.99898C5.84072 10.0879 0.999932 9.57044 0.571431 10.8562",
          fill: "#FFD15A"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.8919 16.5934C5.66277 16.6065 5.43266 16.6214 5.20095 16.638C3.78667 16.7237 3.82953 14.5808 5.20095 14.4951C6.40095 14.4094 7.5581 14.3665 8.7581 14.4094C10.1295 14.4522 10.1295 16.5951 8.7581 16.5522C8.51602 16.5436 8.27568 16.5384 8.03638 16.5364C8.01373 17.3227 8.00157 18.1017 8.02256 18.8963C8.02609 18.9284 8.02842 18.9613 8.02947 18.995V19.1236C8.07233 20.495 5.92947 20.495 5.88661 19.1236C5.85715 18.2692 5.8682 17.4351 5.8919 16.5934Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M19.8149 3.99435C19.9006 2.06578 21.5292 2.45149 22.9863 2.49435C24.5292 2.49435 26.2435 2.32292 27.7435 2.53721C28.8578 2.70864 29.6292 2.96578 29.8863 4.03721C30.0149 4.55149 29.8863 5.15149 29.9292 5.66578C29.972 6.90864 30.0149 8.19435 30.1006 9.43721C30.1863 10.8086 32.3292 10.8086 32.2435 9.43721C32.1578 7.38007 32.4149 5.02292 31.9435 3.00864C31.4721 0.951495 29.672 0.480066 27.7863 0.394352C25.4292 0.265781 22.6435 -0.0770767 20.2863 0.351495C18.3149 0.694352 17.7578 2.06578 17.7149 3.95149C17.6292 5.36578 19.7721 5.36578 19.8149 3.99435Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M17.5011 9.30982C17.4582 11.667 16.6011 16.767 19.2154 18.0098C20.5011 18.6527 22.3011 18.3527 23.6725 18.3955C26.0296 18.3955 28.3868 18.3955 30.7011 18.3955C32.0725 18.3955 32.0725 16.2527 30.7011 16.2527C27.7011 16.2098 24.6582 16.2955 21.6582 16.2527C20.7154 16.2527 20.1582 16.3812 19.7296 15.267C19.5582 14.7098 19.6439 13.9384 19.6011 13.3384C19.5154 12.0098 19.5582 10.6813 19.6011 9.30982C19.6439 7.93839 17.5011 7.93839 17.5011 9.30982Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M22.0439 4.97985C21.7439 5.15128 21.8297 5.837 21.7868 6.09414C21.7011 7.637 21.8296 9.09414 21.8296 10.637C21.8296 11.1941 21.7868 11.6227 21.8725 12.2656C21.9154 12.437 21.8725 12.7799 21.9582 12.9513C22.0868 13.2513 22.4296 13.2941 22.6868 13.2941C24.3154 13.337 25.9439 12.9513 27.5725 13.1227C27.6582 13.1227 27.7011 12.9513 27.7868 12.9084C27.8297 12.8656 28.1297 12.7799 28.1725 12.737C28.3439 12.437 28.3439 12.6084 28.3011 12.2656C28.2582 12.0513 28.3011 11.5799 28.3011 11.3227C28.1297 9.77985 28.1725 5.70843 27.9582 5.15128C27.8725 4.89414 27.5725 4.80843 27.1439 4.80843C26.5011 4.85128 25.3868 4.72271 24.7011 4.67985C24.0582 4.67985 22.3868 4.76557 22.0439 4.97985Z",
          fill: "#F68559"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M21.3154 4.20843C20.2868 5.537 20.7582 7.76557 20.7582 9.30843C20.7582 10.5941 20.2868 13.0799 21.5297 13.9799C22.2154 14.4941 23.1154 14.3656 23.9297 14.3227C25.0868 14.237 26.5011 14.4084 27.6154 14.1941C27.9154 14.1513 28.0868 14.0227 28.3868 13.8941C28.6868 13.7227 28.1297 14.0656 28.4297 13.8513C28.8582 13.5513 29.2011 13.3799 29.3297 12.8227C29.6297 11.7513 29.2868 10.2513 29.2439 9.17985C29.2011 7.89414 29.3725 6.39414 29.0725 5.15128C28.7297 3.69414 27.4868 3.82271 26.2439 3.737C24.8297 3.65128 23.1582 3.437 21.7868 3.95128C20.5011 4.46557 21.0582 6.52271 22.3439 6.00843C23.0725 5.75128 23.9297 5.75128 24.7011 5.75128C25.2582 5.75128 26.2439 6.05128 26.7154 5.87985C27.2297 6.00843 27.3154 5.87985 26.9725 5.45128C26.9725 5.537 26.9725 5.62271 27.0154 5.70843C26.7582 6.26557 27.1011 7.67985 27.1011 8.32271C27.1439 9.26557 27.1868 10.2513 27.2297 11.1941C27.2297 11.4941 27.1439 12.0084 27.2297 12.2656C27.2297 12.7799 27.3582 12.6513 27.5297 11.8799C27.4011 11.9227 27.2725 11.9656 27.1439 12.0513C27.0582 12.0941 26.9725 12.1799 26.9297 12.2656C27.1011 11.8799 26.8868 11.7941 26.3725 11.9656C25.7297 11.837 24.8725 12.0513 24.2297 12.137C23.9297 12.1799 23.6297 12.1799 23.3297 12.1799C22.9011 12.3513 22.7725 12.1799 22.9011 11.6656C22.7297 11.1084 22.9011 10.2084 22.9011 9.65128C22.9011 8.87985 22.8582 8.15128 22.8582 7.37986C22.8582 7.16557 22.7297 5.837 22.8154 5.70843C23.6297 4.67986 22.1297 3.137 21.3154 4.20843Z",
          fill: "#F68559"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M23.6298 8.15086C23.3727 8.66515 23.2441 9.26515 23.3727 9.82229C23.5441 10.5937 24.3584 11.0223 25.087 11.0223C25.8156 11.0223 26.5013 10.6794 26.8441 10.0794C27.2727 9.308 27.0584 8.49372 26.5013 7.85086C25.9441 7.25086 25.087 7.03658 24.3584 7.46515C23.7584 7.76515 23.3298 8.49372 23.3298 9.17943C23.3727 10.0794 24.187 10.5937 25.0013 10.508C25.8584 10.4223 26.7156 9.608 26.4156 8.66515C26.2441 8.19372 25.8584 7.89372 25.387 7.89372C25.387 7.89372 25.387 7.89372 25.3441 7.89372C25.0013 7.85086 24.5727 8.108 24.4013 8.408C24.4013 8.408 24.4013 8.408 24.4013 8.45086C24.1441 8.96515 24.2727 9.65086 24.787 9.908C25.3013 10.1651 25.987 10.0366 26.2441 9.52229C26.2441 9.52229 26.2441 9.52229 26.2441 9.47943C25.9441 9.65086 25.6441 9.82229 25.3013 9.99372C25.3013 9.99372 25.3013 9.99372 25.3441 9.99372C25.0013 9.73658 24.6584 9.47943 24.3156 9.22229C24.2727 8.708 24.4013 8.45086 24.7441 8.408C24.8727 8.36515 24.9155 8.36515 24.8298 8.36515C24.7441 8.36515 24.7441 8.36515 24.9156 8.408C25.087 8.66515 25.2584 8.96515 25.4298 9.22229C25.4298 9.26515 25.387 9.26515 25.387 9.308C25.4298 9.22229 25.4298 9.22229 25.387 9.26515C25.3441 9.308 25.3441 9.308 25.4298 9.22229C25.3441 9.26515 25.3013 9.308 25.2156 9.35086C25.087 9.39372 24.8727 9.22229 24.8298 9.26515C24.787 9.22229 24.787 9.22229 24.8298 9.26515C24.8727 9.308 24.9156 9.308 24.9156 9.35086L24.8727 9.308C24.9584 9.43658 24.9584 9.43658 24.9156 9.26515C24.9156 9.09372 24.9156 9.13658 24.9584 8.96515C24.8727 9.05086 24.9156 9.05086 24.9584 8.96515C25.0441 8.87943 25.0441 8.92229 25.1727 8.87943C25.1298 8.87943 25.087 8.87943 25.087 8.87943C25.1298 8.87943 25.1298 8.87943 25.1727 8.87943C25.087 8.83658 25.0441 8.83658 25.1298 8.87943C25.2156 8.92229 25.3013 8.96515 25.3013 9.09372C25.4298 9.17943 25.4727 9.308 25.4727 9.47943C25.4727 9.43658 25.4727 9.43658 25.4727 9.39372C25.4727 9.35086 25.5155 9.13658 25.4727 9.308C25.4298 9.47943 25.4727 9.26515 25.5156 9.22229C25.6441 8.92229 25.5584 9.13658 25.5156 9.22229C25.7298 8.708 25.687 8.06515 25.1298 7.76515C24.6584 7.55086 23.887 7.63658 23.6298 8.15086Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M23.0727 13.8937C24.187 12.2223 26.3298 12.3937 27.5727 13.8937C27.8298 13.2937 28.087 12.6937 28.3441 12.0509C26.3298 12.2651 24.3155 12.2651 22.2584 12.2651C20.887 12.2651 20.887 14.408 22.2584 14.408C24.2727 14.408 26.3298 14.408 28.3441 14.1937C29.287 14.108 29.7156 13.1223 29.1156 12.3509C26.9727 9.73658 23.0727 10.0366 21.2727 12.7794C20.4584 13.9794 22.3013 15.0509 23.0727 13.8937Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M15.0587 19.8518H11.073C9.65867 19.8518 9.65867 17.709 11.073 17.709H15.0587C16.4301 17.709 16.4301 19.8518 15.0587 19.8518Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M24.573 24.909H6.35867C4.94438 24.909 4.94438 22.7661 6.35867 22.7661H24.573C25.9444 22.7661 25.9444 24.909 24.573 24.909Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M6.18726 30.009H24.7016C26.073 30.009 26.073 27.8661 24.7016 27.8661H6.18726C4.81583 27.8661 4.81583 30.009 6.18726 30.009Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M24.7016 35.0661H6.18726C4.81583 35.0661 4.81583 32.9233 6.18726 32.9233H24.7016C26.073 32.9233 26.073 35.0661 24.7016 35.0661Z",
          fill: "#1E2882"
        }
      )
    ]
  }
), a = (l) => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "42",
    height: "38",
    viewBox: "0 0 42 38",
    fill: "none",
    ...l,
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M5.77506 8.81995C5.77506 6.92973 7.30489 5.3961 9.1951 5.39139L33.2922 5.33142C35.215 5.32664 36.7658 6.90369 36.7287 8.8261L36.3384 29.0602C36.3031 30.8923 34.8334 32.3727 33.0016 32.4214L9.29472 33.0515C7.36618 33.1027 5.77506 31.5533 5.77506 29.6241L5.77506 8.81995Z",
          fill: "#B8DDF0"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M21.9136 25.0627C25.681 20.464 30.2856 13.3568 30.2856 13.3568C30.2856 13.3568 26.5811 12.1159 26.1469 12.143C20.2817 12.5095 13.8202 15.8183 12.2856 22.5543C12.2856 22.5543 15.6345 27.5711 17.3089 27.5711C18.9833 27.5711 21.9136 25.0627 21.9136 25.0627Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M9.6717 4.30071C8.60027 4.30071 7.52885 4.34357 6.45742 4.34357C5.60027 4.34357 4.65742 4.47214 3.80027 4.42928C2.85742 4.38643 2.4717 3.78643 3.3717 3.14357C4.95742 2.02928 4.5717 5.37214 4.5717 6.27214C4.61456 7.77214 4.61456 9.315 4.70027 10.815C4.74313 12.1864 6.88599 12.1864 6.84313 10.815C6.80027 9.18643 6.75742 7.55786 6.71456 5.97214C6.6717 4.815 6.92885 3.18643 6.3717 2.115C5.51456 0.486428 3.32885 0.314999 2.00027 1.47214C0.628846 2.62928 -0.0140113 5.02928 1.74313 6.10071C2.90027 6.78643 4.44313 6.52928 5.68599 6.48643C7.01456 6.44357 8.30027 6.44357 9.62885 6.44357C11.0431 6.44357 11.0431 4.30071 9.6717 4.30071Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M31.1434 6.22925C33.7577 6.22925 36.6719 6.27211 39.2434 5.5864C41.0862 5.07211 41.9862 2.92925 40.7005 1.34354C39.4577 -0.15646 36.9719 -0.0278885 35.9434 1.64354C35.1719 2.84354 35.3434 4.30068 35.3434 5.62925C35.3434 7.21497 35.3005 8.80068 35.3005 10.3864C35.3005 11.7578 37.4434 11.7578 37.4434 10.3864C37.4434 9.01497 37.4434 7.60068 37.4434 6.22925C37.4434 5.50068 37.2719 4.55783 37.4434 3.87211C37.4862 2.80068 37.8719 2.2864 38.6434 2.45783C39.2005 3.01497 39.2434 3.35783 38.7719 3.44354C38.2577 4.04354 35.8577 3.87211 35.1291 3.95783C33.8005 4.04354 32.4291 4.0864 31.1005 4.0864C29.7719 4.0864 29.7719 6.22925 31.1434 6.22925Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M6.58622 17.329C6.58622 17.2862 6.58622 17.2433 6.58622 17.2004C5.85764 17.2004 5.17193 17.2004 4.44336 17.2004C4.44336 19.129 4.44336 21.1004 4.44336 23.029C5.17193 23.029 5.85764 23.029 6.58622 23.029C6.58622 22.6433 6.58622 22.2576 6.58622 21.8719C5.85764 21.8719 5.17193 21.8719 4.44336 21.8719C4.44336 22.2147 4.44336 22.5147 4.44336 22.8576C4.44336 24.229 6.58622 24.229 6.58622 22.8576C6.58622 22.5147 6.58622 22.2147 6.58622 21.8719C6.58622 20.5004 4.44336 20.5004 4.44336 21.8719C4.44336 22.2576 4.44336 22.6433 4.44336 23.029C4.44336 24.4004 6.58622 24.4004 6.58622 23.029C6.58622 21.1004 6.58622 19.129 6.58622 17.2004C6.58622 15.829 4.44336 15.829 4.44336 17.2004C4.44336 17.2433 4.44336 17.2862 4.44336 17.329C4.44336 18.7004 6.58622 18.7004 6.58622 17.329Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M17.6003 6.68389C19.4003 6.59818 21.2003 6.55532 23.0003 6.59818C24.3718 6.64103 24.3718 4.49818 23.0003 4.45532C21.2003 4.41246 19.4003 4.41246 17.6003 4.54103C16.2289 4.62675 16.2289 6.76961 17.6003 6.68389Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M35.3433 16.5579C35.3433 18.4436 35.3433 20.3293 35.3433 22.215C36.0718 22.215 36.7575 22.215 37.4861 22.215C37.4861 21.4864 37.4861 20.715 37.4861 19.9864C37.4861 18.615 35.3433 18.615 35.3433 19.9864C35.3433 20.715 35.3433 21.4864 35.3433 22.215C35.3433 23.5864 37.4861 23.5864 37.4861 22.215C37.4861 20.3293 37.4861 18.4436 37.4861 16.5579C37.4861 15.1864 35.3433 15.1864 35.3433 16.5579Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M4.40034 29.4149C4.4432 30.1434 4.4432 30.872 4.48606 31.6434C4.52892 32.5006 4.87177 34.5148 4.4432 35.2863C3.75749 36.4434 2.72892 34.772 3.58606 34.2149C3.97177 33.9577 5.00034 34.172 5.51463 34.172C6.88606 34.2149 8.25749 34.172 9.62892 34.1291C11.0003 34.0863 11.0003 31.9434 9.62892 31.9863C8.0432 32.0291 6.50034 31.9863 4.95749 31.9863C3.97177 31.9863 2.9432 31.9863 2.08606 32.5863C0.457487 33.7434 0.886058 36.1006 2.30034 37.2148C3.80034 38.4148 5.90034 37.9863 6.50034 36.0577C7.1432 34.0006 6.71463 31.5149 6.62892 29.372C6.50034 28.0434 4.35749 28.0434 4.40034 29.4149Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M17.2146 33.9576C19.486 33.8719 21.7146 33.9148 23.986 33.829C25.3575 33.7862 25.3575 31.6433 23.986 31.6862C21.7575 31.7719 19.486 31.729 17.2146 31.8148C15.8432 31.8576 15.8432 34.0005 17.2146 33.9576Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M35.2577 28.9852C35.2577 30.1423 35.3862 31.2137 35.2577 32.328C35.1291 33.528 35.1291 34.5137 35.8148 35.5423C36.8434 37.0423 38.8148 37.8566 40.1005 36.2709C41.1719 34.9852 41.1291 32.8423 39.7148 31.8566C38.6434 31.0852 37.4005 31.2566 36.1577 31.3423C34.7434 31.428 33.3291 31.428 31.9148 31.428C30.5434 31.428 30.5434 33.5709 31.9148 33.5709C33.2434 33.5709 34.5719 33.5709 35.9434 33.4852C36.5005 33.4423 37.2291 33.2709 37.7862 33.3995C38.3005 33.4852 39.1577 34.1709 38.5577 34.8137C38.2577 35.1137 38.0862 34.9423 37.7434 34.5566C37.1862 33.9137 37.3148 33.1423 37.4005 32.3709C37.5291 31.2137 37.4434 30.0995 37.4005 28.9423C37.3577 27.6137 35.2148 27.6137 35.2577 28.9852Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M26.272 11.4662C24.9487 9.78434 22.1417 10.6048 20.4976 11.2611C17.7307 12.4097 15.6456 14.5838 14.0416 17.1271C12.4777 19.6704 11.4752 22.747 13.1594 25.4954C14.5228 27.7515 17.1292 27.9977 19.3748 27.0542C22.1818 25.9056 24.3873 23.2392 26.1918 20.86C27.1541 19.5473 28.0363 18.1526 28.7982 16.7169C29.4398 15.4863 30.322 14.0505 30.2819 12.6148C30.2418 10.2766 28.2368 9.86638 26.6729 11.138C24.7883 12.6968 23.3848 15.1581 22.3422 17.3322C20.8986 20.3267 20.2169 23.1982 22.9036 25.6185C25.7507 28.2028 28.2368 26.767 30.8032 24.5519C31.8057 23.6905 30.3621 22.2547 29.3997 23.1162C28.2368 24.1007 26.9536 25.4954 25.3497 24.8391C23.9061 24.2648 22.8635 22.747 23.064 21.1472C23.3447 19.0551 24.8685 16.7989 25.9913 15.0761C26.4324 14.4197 26.8734 13.8044 27.3947 13.2711C28.7982 11.8354 28.1165 13.4762 27.6754 14.4607C26.6729 16.6348 25.4299 18.7269 23.9061 20.5729C22.4625 22.3368 20.7783 24.3058 18.6129 25.2082C15.0842 26.644 13.4401 22.9111 14.8035 19.9165C15.806 17.7014 17.4901 15.4452 19.4951 14.0915C20.4575 13.4352 23.8259 11.6303 24.8284 12.9019C25.6304 13.9275 27.0739 12.4917 26.272 11.4662Z",
          fill: "#1E2882"
        }
      )
    ]
  }
), h = (l) => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "35",
    height: "39",
    viewBox: "0 0 35 39",
    fill: "none",
    ...l,
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M22.5424 3.20204C25.9778 2.57967 30.3039 3.36801 32.3821 6.14794C34.2482 8.63744 35.0116 11.9568 34.7147 15.0271C34.3754 18.222 32.2548 20.9604 29.5829 22.7446C27.7167 23.9893 25.2568 24.1968 23.0938 23.6159C20.9308 23.035 17.9195 22.1222 16.4351 20.4625C14.1449 17.8071 13.9328 15.0686 13.7207 11.5833C13.6359 10.0067 14.3993 7.06076 15.8837 6.52137C15.9262 6.52137 19.1071 3.82441 22.5424 3.20204Z",
          fill: "#FFD15A"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M1.8327 35.9611C1.63768 28.4442 1.63768 20.966 1.7937 13.449C1.7937 12.8397 2.23658 12.5207 2.70025 12.488C2.72207 12.472 2.74492 12.4566 2.76882 12.4416C7.48845 8.10597 10.9989 5.78114 15.1333 2.87105C15.7184 2.28985 16.8495 2.71606 16.8105 3.5685C16.6807 8.52701 16.9833 13.4855 17.286 18.444C17.6195 23.9085 17.953 29.373 17.7077 34.8375C17.6687 35.4187 17.2786 35.7287 16.7325 35.8062C12.091 36.3486 7.44939 36.7361 2.80782 36.9298C2.26176 36.9686 1.8327 36.4649 1.8327 35.9611Z",
          fill: "#B8DDF0"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M1.44194 11.5952C6.11119 7.64967 11.0475 4.00759 16.2509 0.743893C16.7614 0.174059 17.9805 0.379301 17.9805 1.35962C18.1106 6.73762 18.1713 12.0984 18.232 17.4649C18.2623 20.1406 18.2926 22.8177 18.3315 25.4991C18.3315 26.739 16.3813 26.739 16.3813 25.4991C16.3424 22.8177 16.3121 20.1406 16.2818 17.4649C16.2278 12.6934 16.1738 7.92646 16.0711 3.14789C11.4844 6.11024 7.0919 9.35532 2.92254 12.8545L2.81207 36.2291C7.62718 35.5021 12.4753 35.1084 17.3565 35.1084C18.6046 35.1084 18.6046 37.0458 17.3565 37.0458C12.2468 37.0458 7.13721 37.4332 2.06659 38.2857C1.41683 38.3898 0.969816 37.9009 0.882892 37.3962C0.866312 37.3238 0.857422 37.2457 0.857422 37.162L0.974436 12.4026C0.974436 12.0076 1.17228 11.7385 1.44194 11.5952Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M18.2927 8.83781C21.4911 8.3341 24.7285 8.25661 27.9659 8.37285C27.6539 8.06287 27.3028 7.71414 26.9908 7.40417C27.1858 14.4562 27.3808 21.5081 27.6539 28.5989C27.6929 29.8388 29.6431 29.8388 29.6041 28.5989C29.3311 21.5469 29.136 14.4949 28.941 7.40417C28.941 6.86171 28.512 6.47424 27.9659 6.43549C24.5335 6.31925 21.14 6.43549 17.7856 6.97795C16.5375 7.17168 17.0445 9.03155 18.2927 8.83781Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M19.3067 33.5969C21.179 33.3645 23.0902 33.2482 24.9624 33.287C26.2106 33.287 26.2106 31.3496 24.9624 31.3496C23.0512 31.3496 21.179 31.4659 19.3067 31.6596C18.0586 31.8146 18.0586 33.7519 19.3067 33.5969Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M18.0195 13.5651C20.2038 13.3713 22.388 13.1776 24.5723 13.1776C25.8204 13.1776 25.8204 11.2402 24.5723 11.2402C22.9341 11.2402 21.2959 11.371 19.6577 11.5018C19.1116 11.5454 18.5656 11.589 18.0195 11.6277C16.7713 11.7052 16.7713 13.6426 18.0195 13.5651Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M18.0195 20.2296C19.9307 20.0262 21.842 20.0304 23.7532 20.0346L23.7552 20.0346C24.0276 20.0352 24.2999 20.0358 24.5723 20.0358C25.8204 20.0358 25.8204 18.0985 24.5723 18.0985C22.388 18.0985 20.2038 18.0985 18.0195 18.2922C16.7713 18.4085 16.7713 20.3458 18.0195 20.2296Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M24.2993 26.0029C22.076 26.0029 19.8137 26.0029 17.6295 26.4291C16.4203 26.6616 15.8742 24.8017 17.0834 24.5693C19.4627 24.1043 21.881 24.0655 24.2993 24.0655C25.5474 24.0655 25.5474 26.0029 24.2993 26.0029Z",
          fill: "#1E2882"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M3.7824 18.0195C4.67951 22.2042 5.49862 26.4276 6.43473 30.6123C6.62976 31.5035 8.15094 31.5422 8.30696 30.6123C9.00905 26.7376 9.47711 22.7854 10.0232 18.8719C9.3991 18.8719 8.77502 18.8719 8.15094 18.8719C8.89203 22.1267 9.67213 25.3814 10.7643 28.5587C11.1153 29.6049 12.5975 29.4112 12.6755 28.2875C13.1046 23.1729 13.5726 18.0582 14.0017 12.9436C14.1187 11.7037 12.1684 11.7037 12.0514 12.9436C11.6224 18.0582 11.1543 23.1729 10.7253 28.2875C11.3493 28.21 12.0124 28.1325 12.6365 28.0163C11.5444 24.839 10.7643 21.623 10.0232 18.3295C9.82815 17.4383 8.26796 17.3608 8.15094 18.3295C7.56587 22.2429 7.13682 26.1564 6.43473 30.0699C7.05881 30.0699 7.68288 30.0699 8.30696 30.0699C7.37085 25.8852 6.55175 21.6617 5.65464 17.477C5.42061 16.2759 3.54838 16.7796 3.7824 18.0195Z",
          fill: "#1E2882"
        }
      )
    ]
  }
), d = (l) => /* @__PURE__ */ i(
  "svg",
  {
    width: "56",
    height: "56",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l,
    children: [
      /* @__PURE__ */ i("g", { filter: "url(#filter0_di_4885_8205)", children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M22.1615 3.30787C24.8044 -1.10263 31.1956 -1.10262 33.8385 3.30787C35.3798 5.88003 35.6403 9.92311 38.5489 9.1942C43.5364 7.94433 48.0557 12.4636 46.8058 17.4511C46.0769 20.3598 50.12 20.6202 52.6921 22.1615C57.1026 24.8044 57.1026 31.1956 52.6921 33.8385C50.12 35.3798 46.0769 35.6403 46.8058 38.5489C48.0557 43.5364 43.5364 48.0557 38.5489 46.8058C35.6403 46.0769 35.3798 50.12 33.8385 52.6921C31.1956 57.1026 24.8044 57.1026 22.1615 52.6921C20.6202 50.12 20.3598 46.0769 17.4511 46.8058C12.4636 48.0557 7.94433 43.5364 9.1942 38.5489C9.92311 35.6403 5.88003 35.3798 3.30787 33.8385C-1.10262 31.1956 -1.10262 24.8044 3.30787 22.1615C5.88003 20.6202 9.92311 20.3598 9.1942 17.4511C7.94433 12.4636 12.4636 7.94433 17.4511 9.1942C20.3598 9.92311 20.6202 5.88003 22.1615 3.30787Z",
            fill: "#E846E8"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M22.1615 3.30787C24.8044 -1.10263 31.1956 -1.10262 33.8385 3.30787C35.3798 5.88003 35.6403 9.92311 38.5489 9.1942C43.5364 7.94433 48.0557 12.4636 46.8058 17.4511C46.0769 20.3598 50.12 20.6202 52.6921 22.1615C57.1026 24.8044 57.1026 31.1956 52.6921 33.8385C50.12 35.3798 46.0769 35.6403 46.8058 38.5489C48.0557 43.5364 43.5364 48.0557 38.5489 46.8058C35.6403 46.0769 35.3798 50.12 33.8385 52.6921C31.1956 57.1026 24.8044 57.1026 22.1615 52.6921C20.6202 50.12 20.3598 46.0769 17.4511 46.8058C12.4636 48.0557 7.94433 43.5364 9.1942 38.5489C9.92311 35.6403 5.88003 35.3798 3.30787 33.8385C-1.10262 31.1956 -1.10262 24.8044 3.30787 22.1615C5.88003 20.6202 9.92311 20.3598 9.1942 17.4511C7.94433 12.4636 12.4636 7.94433 17.4511 9.1942C20.3598 9.92311 20.6202 5.88003 22.1615 3.30787Z",
            fill: "white",
            fillOpacity: "0.88"
          }
        )
      ] }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ i(
        "filter",
        {
          id: "filter0_di_4885_8205",
          x: "-2.33333",
          y: "-4.66667",
          width: "60.6667",
          height: "60.6667",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [
            /* @__PURE__ */ C("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            /* @__PURE__ */ C(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }
            ),
            /* @__PURE__ */ C("feOffset", { dy: "-2.33333" }),
            /* @__PURE__ */ C("feGaussianBlur", { stdDeviation: "1.16667" }),
            /* @__PURE__ */ C("feComposite", { in2: "hardAlpha", operator: "out" }),
            /* @__PURE__ */ C("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" }),
            /* @__PURE__ */ C("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_4885_8205" }),
            /* @__PURE__ */ C(
              "feBlend",
              {
                mode: "normal",
                in: "SourceGraphic",
                in2: "effect1_dropShadow_4885_8205",
                result: "shape"
              }
            ),
            /* @__PURE__ */ C(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }
            ),
            /* @__PURE__ */ C("feOffset", {}),
            /* @__PURE__ */ C("feGaussianBlur", { stdDeviation: "3.5" }),
            /* @__PURE__ */ C("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
            /* @__PURE__ */ C(
              "feColorMatrix",
              {
                type: "matrix",
                values: "0 0 0 0 0.909804 0 0 0 0 0.27451 0 0 0 0 0.909804 0 0 0 0.4 0"
              }
            ),
            /* @__PURE__ */ C("feBlend", { mode: "normal", in2: "shape", result: "effect2_innerShadow_4885_8205" })
          ]
        }
      ) })
    ]
  }
), f = (l) => /* @__PURE__ */ i(
  "svg",
  {
    width: "56",
    height: "56",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l,
    children: [
      /* @__PURE__ */ i("g", { clipPath: "url(#clip0_34_8982)", children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M25.7734 1.40015C26.0968 1.45845 26.4202 1.49618 26.7368 1.57507C27.4492 1.74945 28.0899 2.1432 28.5699 2.70155C29.0498 3.25989 29.3452 3.95507 29.4149 4.6904C29.4845 5.42573 29.325 6.16466 28.9585 6.8044C28.592 7.44413 28.0367 7.95289 27.3699 8.25989C26.4066 8.70577 25.4262 8.94586 24.3778 8.56515C23.5849 8.31841 22.906 7.79341 22.4644 7.08543C22.0229 6.37746 21.8478 5.53344 21.9711 4.70654C22.0792 3.88161 22.4549 3.11582 23.0398 2.52837C23.6247 1.94092 24.3859 1.56476 25.205 1.45845C25.299 1.44431 25.3922 1.42484 25.4841 1.40015H25.7734Z",
            fill: "#1A91F0"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M26.4538 51.0749C12.31 51.0749 7.0814 53.4759 7.05077 44.4141C7.03375 40.3292 6.16912 25.9443 12.31 30.8387C14.4614 32.5536 12.6028 42.4625 13.8486 45.5871C20.2721 46.0708 38.9807 45.6798 41.2137 44.5582C41.6529 40.3532 39.9066 32.2106 43.0553 29.8097C48.6754 25.5018 47.4806 40.5521 47.5316 44.8017C47.6678 53.8188 43.3651 51.0749 26.4538 51.0749Z",
            fill: "#1A91F0"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M24.4905 18.6285C24.048 19.0984 21.4779 22.5454 20.8073 23.0873C20.5715 23.2919 20.2959 23.4446 19.9981 23.5355C19.7003 23.6265 19.3869 23.6538 19.0781 23.6155C17.822 23.4372 17.1139 22.2436 17.4918 20.9848C17.873 18.9269 20.8958 16.526 22.2847 14.4681C22.5229 14.1251 24.1909 11.4326 24.4905 11.1342C25.6138 10.0092 26.1925 9.9818 27.5269 10.8564C28.1805 11.292 29.9574 14.2314 30.5599 14.7459C32.5546 16.4608 33.5248 17.0062 34.9851 19.2047C35.5366 20.0416 35.717 21.6056 34.9307 22.2367C34.6207 22.5408 34.223 22.7378 33.7947 22.7995C33.3665 22.8611 32.9299 22.7842 32.5478 22.5797C31.656 22.2024 31.1147 21.441 30.2876 20.6075C29.1846 19.4963 28.3983 18.6662 28.0817 18.3816C28.1022 18.7554 28.7898 25.3202 28.9089 28.1087C29.0281 30.9658 29.314 33.0374 29.4604 35.891C29.5863 38.4051 28.2485 39.5404 27.2546 39.5027C26.8097 39.486 26.3729 39.378 25.9708 39.1854C25.5687 38.9928 25.2099 38.7196 24.9161 38.3826C24.6224 38.0455 24.3999 37.6516 24.2624 37.225C24.1248 36.7984 24.075 36.348 24.116 35.9013C24.2182 33.6685 24.4939 32.5572 24.4939 26.7196C24.5075 24.9806 24.4871 18.752 24.4905 18.6285Z",
            fill: "#1A91F0"
          }
        )
      ] }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_34_8982", children: /* @__PURE__ */ C("rect", { width: "40.6", height: "53.5574", fill: "white", transform: "translate(7 1.40002)" }) }) })
    ]
  }
), r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Builder: a,
  Costumization: t,
  Star: d,
  Template: e,
  UploadResume: f,
  Word: h
}, Symbol.toStringTag, { value: "Module" }));
export {
  a as B,
  t as C,
  d as S,
  e as T,
  f as U,
  h as W,
  r as _
};
